export default Object.freeze({
  CreateRequest: 1,
  ViewDetails: 2,
  CancelRequest: 3,
  CompleteRequestInformation: 4,
  ApproveRequest: 5,
  ExecuteTask: 6,
  SignDocument: 7,
  ReassignTask: 8,
  MassRequestsApprove: 9,
  Export: 10,
  MassRequestsReject: 11,
  EntityAdd: 12,
  EntityEdit: 13,
  EntityDelete: 14,
  EntityImport: 15,
  ActionCustomCommands: 16,
  MassRequestsCancel: 17,
  VoidRequest: 18,
  MassRequestsVoid: 19,
  MassRequestsExecuteTask: 20,
  MassRequestsCompleteRequestInformation: 21,
  // Local commands, not provided by API. Kept out of the 1..21 backend
  // range so the numeric (legacy) path never collides with a server value.
  RejectRequest: 1001,
  SetFavorite: 1002,
});
